export var DOCUMENT_IMAGE_PLACEHOLDER = undefined;
export var PRODUCT_IMAGE_PLACEHOLDER = {
    name: 'b49ee3_c1990078a34745ae8e98cdc1bfae1a48~mv2.png',
};
//# sourceMappingURL=DocumentParser.constants.js.map